import src from "IMAGE";
export default { src, width: 140, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARUlEQVR42hXKOxKAIAwE0K0cO0dmI0kAv50VauX9Lyb2D1WQb0F6BOVVbHPoJ1XNZraQNBwDeI6IlUhXw3voYgPF3dcffMVmBd63AYD0AAAAAElFTkSuQmCC"};
